<app-spinner [isLoading]="isLoading$ | async">
  @if ({
    isJobseekerPasswordChangeRequired: isJobseekerPasswordChangeRequired$ | async,
    isJobseekerEmailChangeRequested: isJobseekerEmailChangeRequested$ | async
  }; as data) {
    <div class="page">
      <p-tabs
        class="tabs"
        scrollable
        [value]="data.isJobseekerEmailChangeRequested || data.isJobseekerPasswordChangeRequired ? 0 : 1"
      >
        <p-tablist>
          <p-tab [value]="0">{{ 'label.UserPassword' | translate }}</p-tab>
          <p-tab [value]="1">{{ 'label.Privacy' | translate }}</p-tab>
          <p-tab [value]="2">{{ 'label.BlackList' | translate }}</p-tab>
        </p-tablist>

        <p-tabpanels>
          <p-tabpanel [value]="0">
            <div class="account">
              <app-jobseeker-settings-change-email></app-jobseeker-settings-change-email>
              <app-jobseeker-settings-change-password></app-jobseeker-settings-change-password>
            </div>
          </p-tabpanel>

          <!-- Privacy -->
          <p-tabpanel [value]="1">
            <app-spinner [isLoading]="isUpdating$ | async" [isFixedPosition]="false">
              <app-jobseeker-settings-privacy></app-jobseeker-settings-privacy>
            </app-spinner>
          </p-tabpanel>

          <!-- BlackList -->
          <p-tabpanel [value]="2">
            <app-spinner [isLoading]="isUpdating$ | async" [isFixedPosition]="false">
              <app-jobseeker-settings-blacklist></app-jobseeker-settings-blacklist>
            </app-spinner>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  }
</app-spinner>
